body {
  display: flex;
}

h1 {
  text-align: center;
}

hr {
  color: #ddd;
  width: 100%;
}

.browser-not-supported {
  background-color: #343434;
  display: flex;
  flex-direction: column;
  margin: auto;
  padding: 0px 16px 16px 16px;
  font-family:
    Menlo,
    Monaco,
    Lucida Console,
    Liberation Mono,
    DejaVu Sans Mono,
    Bitstream Vera Sans Mono,
    Courier New,
    monospace,
    serif;
  width: 80vw;

  code {
    font-size: 17.5px;
    background-color: #3f3f3f;
    padding: 2px 4px 2px 4px;
    border-radius: 0.2em;
  }
}
